import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import breakpoints from "assets/theme/base/breakpoints";
import backgroundImage from "assets/images/bg-profile.jpeg";
import MDButton from "components/MDButton";

function Header({
  profilePicture,
  preferredName,
  jobTitle,
  onPressAwardTrail,
  onPressCustomReferralCodes,
  onPressDisableUser,
  isActiveUser,
  children,
}) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  // const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  // const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={1}>
            <MDAvatar src={profilePicture} alt="profile-image" size="xl" shadow="sm" />
          </Grid>
          <Grid item xs={4}>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {preferredName}
              </MDTypography>
              {/* <MDTypography variant="button" color="text" fontWeight="regular">
                {jobTitle || "Job Title"}
              </MDTypography> */}
            </MDBox>
          </Grid>
          <Grid style={{ textAlign: "right" }} item xs={7}>
            <MDButton
              className="w-15 align-self-end m-1"
              onClick={onPressAwardTrail}
              variant="gradient"
              color="success"
            >
              Award Trial
            </MDButton>
            <MDButton
              className="w-15 align-self-end m-1"
              onClick={onPressCustomReferralCodes}
              variant="gradient"
              color="success"
            >
              Custom Referral Codes
            </MDButton>
            <MDButton
              // disabled={!preferredName}
              className="w-15 align-self-end m-1"
              onClick={onPressDisableUser}
              variant="gradient"
              color={isActiveUser ? "error" : "secondary"}
            >
              {isActiveUser ? "Suspend User" : "Activate User"}
            </MDButton>
          </Grid>
          {/* <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label="App"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      home
                    </Icon>
                  }
                />
                <Tab
                  label="Message"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      email
                    </Icon>
                  }
                />
                <Tab
                  label="Settings"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      settings
                    </Icon>
                  }
                />
              </Tabs>
            </AppBar>
          </Grid> */}
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  profilePicture: "",
  preferredName: "",
  jobTitle: "",
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  profilePicture: PropTypes.node,
  preferredName: PropTypes.node,
  jobTitle: PropTypes.node,
  children: PropTypes.node,
};

export default Header;
